import PrimeiraConsultaProgramadaIcon from '@/components/icons/IndicadoresEsb/Ampliados/Prevencao.vue'

export default {
  value: 'b1',
  label: 'Primeira consulta',
  iconType: 'component',
  iconComponent: PrimeiraConsultaProgramadaIcon,
  buscaAtiva: {
    // a: ({ cidadao, formatDate }) =>
    //   `Cidadão ${cidadao?.no_cidadao || '-'} nascido em ${
    //     cidadao?.dt_nascimento ? formatDate(cidadao.dt_nascimento) : '-'
    //   }.`,
    a: 'Pessoa sem realização de primeira consulta odontológica programática ou tratamento odontológico concluído nos últimos 12 meses.',
  },
}
